import { IoMdMore } from "react-icons/io";
import { BsCash, BsCashCoin } from "react-icons/bs";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { FaMoneyBillTransfer, FaMoneyBillTrendUp } from "react-icons/fa6";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, TextField, Typography } from "@mui/material";
import { GiSandsOfTime } from "react-icons/gi";
import { MdSmsFailed } from "react-icons/md";
import { useSelector } from "react-redux";
import { RootState } from "@/store/type";
import { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { UploadFile } from "@mui/icons-material";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";
import useTransform from "@/app/features/Transformation/hook/use-transform";
import { showToast } from "@/app/global-components/toaster";

interface Transformation {
  type: string;
  id: string;
  title: string;
  status: "Pending" | "Accepted" | "Refused";
  buyerId: string;
  sellerId: string;
  userId: string;
  orderId: string;
  totalPrice: number;
  transformRequest: boolean;
  withdrawRequest: boolean;
  createdAt: Date;
}
interface BankAccount {
  accountName?: string;
  accountNumber?: string;
  bankName?: string | null;
  iban?: string;
}
function LandingpaymentSeller() {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [AvailableCount, setAvailableCount] = useState(0);
  const [PendingValue, setPendingValue] = useState(0);
  const [TransformedValue, setTransformedValue] = useState(0);
  const [transformations, setTransformations] = useState<Transformation[]>([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopup1Open, setIsPopup1Open] = useState(false);
  const [bankAccount, setBankAccount] = useState<BankAccount>({
    accountName: "",
    accountNumber: "",
    bankName: "",
    iban: "",
  });

  const bankInfo = {
    accountName: "شركة ميدا المتقدمة لحلول الاعمال",
    accountNumber: "212000010006086127973",
    iban: "SA0780000212608016127973",
    bankName: "بنك الراجحي",
  };
  const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const { fetchTransforms, upsertTransform } = useTransform();
  const [withdrawAmount, setWithdrawAmount] = useState(0);
  const handleOpenPopup = () => setIsPopupOpen(true);
  const handleClosePopup = () => setIsPopupOpen(false);
  const handleConfirmOpenPopup = () => setIsPopup1Open(true);
  const handleClosePopup2 = () => setIsPopup1Open(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);

  const handleBankAccountChange = (field: keyof BankAccount, value: string) => {
    setBankAccount((prev) => ({ ...prev, [field]: value }));
  };
  const handleFileUpload = (file: File) => {
    setUploadedFile(file);
  };
  //handleCreateAdd
  const handleCreateAdd = async ()=>{
    if (withdrawAmount <= 0) {
      showToast(t("Alert.EnterValidAmount"), "warning");
      return;
    }

    // Validation: Ensure a file is uploaded
    if (!uploadedFile) {
      showToast(t("Alert.UploadTransferProof"), "warning");
      return;
    }
    try {
      const transformationPayload = {
        title:"Transfer",
        status:"Pending",
        sellerId: myCompany.id,
        withdrawRequest: false,
        transformRequest: false,
        type:"Transfer",
        totalPrice: withdrawAmount,
        attachment: uploadedFile,
      };

      const response = await upsertTransform(transformationPayload);
      if (response.isSuccess) {
        showToast(t("Alert.TransactionCreated"), "success");
        handleClosePopup2();
        // Refresh the list of transformations
        const refreshedTransforms = await fetchTransforms({
          sellerId: myCompany.id,
          pageSize: 10,
          pageNumber: 0,
          withPaging: false,
        });
        setTransformations(refreshedTransforms?.data || []);
      } else {
        showToast(response.message || t("Alert.TransactionCreationFailed"), "warning");
      }
    } catch (error) {
      showToast(t("Alert.TransactionErrorTryAgain"), "warning");
      console.error("Error creating transformation:", error);
    }
  }
  const handleCreateTransform = async () => {
    
    if (withdrawAmount > AvailableCount) {
      showToast(t("Alert.WithdrawExceedsBalance"), "warning");
      return;
    }
    try {
      let bank = []
      bank.push(bankAccount)
      const transformationPayload = {
        title:"Withdraw",
        status:"Pending",
        sellerId: myCompany.id,
        withdrawRequest: false,
        bankAccount: JSON.stringify(bank),
        type:"withdraw",
        totalPrice: withdrawAmount,
      };

      const response = await upsertTransform(transformationPayload);
      if (response.isSuccess) {
        showToast(t("Alert.WithdrawCreated"), "success");
        handleClosePopup();
        // Refresh the list of transformations
        const refreshedTransforms = await fetchTransforms({
          sellerId: myCompany.id,
          pageSize: 10,
          pageNumber: 0,
          withPaging: false,
        });
        setTransformations(refreshedTransforms?.data || []);
      } else {
        showToast(response.message || t("Alert.WithdrawFailed"), "warning");
      }
    } catch (error) {
      showToast(t("Alert.WithdrawErrorTryAgain"), "warning");
      console.error("Error creating transformation:", error);
    }
  };

  useEffect(() => {
    const loadItems = async () => {
      try {
        const response = await fetchTransforms({
          sellerId: myCompany.id,
          pageSize: 10,
          pageNumber: 0,
          withPaging: false,
        }); // Fetch transformations for the seller
        const transforms = response?.data || [];
        setTransformations(transforms);

        // Calculate values
        const total = transforms.reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);
        const pending = transforms
          .filter((t: Transformation) => t.status === "Pending")
          .reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);
        const transformed = transforms
          .filter((t: Transformation) => t.withdrawRequest)
          .reduce((sum: number, t: Transformation) => sum + t.totalPrice, 0);

        setAvailableCount(total - pending - transformed);
        setPendingValue(pending);
        setTransformedValue(transformed);
      } catch (error) {
        console.error("Error fetching transformations:", error);
      }
    };
    loadItems();
  }, [myCompany]);

  return (
    <div className="h-full w-full">
      <div className="px-4 py-5 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Available Funds */}
        <div className="text-2xl font-bold text-neutral-500">
          <div className="h-60 rounded-xl relative bg-gradient-100 mt-2 p-4">
            <IoMdMore className="absolute top-5 left-4 text-white" />
            <div className="flex flex-col h-full gap-5">
              <div className="rounded-full border-white border-2 w-fit p-2">
                <BsCash className="text-white" />
              </div>
              <div className="flex flex-col h-full justify-between">
                <div>
                  <div className="text-white text-xl">{t("wallet.currentBalance")}:</div>
                  {/*<div className="text-white text-xl">متوفر حاليا</div>*/}
                  <div className="text-white text-4xl mt-6">
                    {AvailableCount} {t("checkout.summary.currency")}
                  </div>
                </div>
                <div className="text-white text-sm flex items-center gap-2 cursor-pointer">
                  {t("actions.enableAutoTransfer")} <HiArrowNarrowLeft className="text-xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pending Funds */}
        <div className="text-2xl font-bold text-neutral-500">
          <div className="h-60 rounded-xl relative bg-gradient-200 mt-2 p-4">
            <IoMdMore className="absolute top-5 left-4 text-white" />
            <div className="flex flex-col h-full gap-5">
              <div className="rounded-full border-white border-2 w-fit p-2">
                <FaMoneyBillTrendUp className="text-white" />
              </div>
              <div className="flex flex-col h-full justify-between">
                <div>
                  <div className="text-white text-xl"> {t("status.underReview")} :</div>
                  {/*<div className="text-white text-xl">المبلغ تم الحجز عليه</div>*/}
                  <div className="text-white text-4xl mt-6">
                    {PendingValue} {t("checkout.summary.currency")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Transformed Funds */}
        <div className="text-2xl font-bold text-neutral-500">
          <div className="h-60 rounded-xl relative bg-gradient-300 mt-2 p-4">
            <IoMdMore className="absolute top-5 left-4 text-white" />
            <div className="flex flex-col h-full gap-5">
              <div className="rounded-full border-white border-2 w-fit p-2">
                <FaMoneyBillTransfer className="text-white" />
              </div>
              <div className="flex flex-col h-full justify-between">
                <div>
                  <div className="text-white text-xl">{t("wallet.withdrawnMoney")} :</div>
                  {/*<div className="text-white text-xl">الانفاقات و التحويلات</div>*/}
                  <div className="text-white text-4xl mt-6">
                    {TransformedValue} {t("checkout.summary.currency")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Transaction Log */}
      <div className="bg-white mx-4 rounded-2xl py-4">
        <div className="mb-8 px-4 text-2xl flex justify-between">
          <div>{t("wallet.transferHistory")}</div>
          <div>
            <Button
              className="!bg-black !text-white !text-md hover:!bg-zinc-700"
              onClick={handleConfirmOpenPopup}
              style={{  margin: "auto 10px",display:"none"}}
            >
              {t("actions.addBalance")}
            </Button>
            <Button
              className="!bg-black !text-white !text-md hover:!bg-zinc-700"
              onClick={handleOpenPopup}
            >
            {t("actions.withdraw")}
            </Button>
          </div>
        </div>
        <div className="flex flex-col px-4 w-full gap-2 md:h-[calc(50vh-100px)] overflow-y-scroll no-scrollbar">
          <div className="border-b border-zinc-200 grid grid-cols-5 sticky text-gray-500 top-0 bg-white z-10 h-16 w-full">
            <div className="p-4 text-start font-bold">{t("wallet.date")}</div>
            <div className="p-4 text-start font-bold">{t("orders.fields.status")}</div>
            <div className="p-4 text-start font-bold">{t("item.fields.type")}</div>
            <div className="p-4 text-start font-bold">{t("wallet.amount")}</div>
            <div className="p-4 text-start font-bold">{t("navigation.Settings")}</div>
          </div>
          {transformations.map((transform, index) => (
            <div key={index} className="flex flex-col px-2 gap-2 text-gray-700 font-semibold">
              <div className="grid grid-cols-5 items-center cursor-pointer hover:scale-[1.01] !rounded-2xl">
                <div className="p-4">{new Date(transform.createdAt).toLocaleDateString()}</div>
                <div className="p-4">
                  <div
                    className={`w-fit flex items-center gap-2 rounded-xl p-2 ${
                      transform.status === "Refused"
                        ? "text-red-500"
                        : transform.status === "Accepted"
                        ? "text-green-500"
                        : "text-gray-500"
                    }`}
                  >
                    {transform.status === "Refused" && <MdSmsFailed />}
                    {transform.status === "Accepted" && <BsCashCoin />}
                    {transform.status === "Pending" && <GiSandsOfTime />}
                    {transform.status}
                  </div>
                </div>
                <div className="p-4">{transform.type}</div>
                <div className="p-4 flex items-center gap-2">
                  {transform.totalPrice} {t("checkout.summary.currency")}
                </div>
                <div className="p-4 flex items-center gap-2">
                  <IoMdMore className="text-xl" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
     
      <Dialog
  open={isPopup1Open}
  onClose={handleClosePopup2}
  maxWidth="sm"
  fullWidth
>
  <DialogTitle>{t("actions.addBalance")}</DialogTitle>
  <DialogContent>
    <Typography variant="body1" sx={{ mb: 2 }}>
      <strong>{t("orders.fields.totalPrice")}:</strong> {AvailableCount} {t("checkout.summary.currency")}
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Typography variant="body1" sx={{ mb: 2 }}>
      <strong>{t("payment.bankInfo")}:</strong>
      <br />
      <strong>{t("payment.accountName")}:</strong>{bankInfo.accountName}
      <br />
      <strong>{t("payment.accountNumber")}:</strong> {bankInfo.accountNumber}
      <br />
      <strong>{t("payment.iban")}:</strong> {bankInfo.iban}
      <br />
      <strong>{t("payment.bankName")}:</strong> {bankInfo.bankName}
    </Typography>
    <Divider sx={{ mb: 2 }} />
    <Typography variant="body1" sx={{ mb: 2 }}>
      <strong>{t("payment.uploadTransferImage")}:</strong>
    </Typography>
    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
      <FileUploader
        handleChange={handleFileUpload}
        name="file"
        types={["jpg", "png", "pdf"]}
        maxSize={5}
        label={t("general.DragOrClickToUpload")}
      />
      {uploadedFile && (
        <Typography variant="body2">
          <UploadFile /> {uploadedFile.name}
        </Typography>
      )}
    </Box>
    <Divider sx={{ my: 2 }} />
    <Typography variant="body2" sx={{ mt: 2 }}>
      <strong>{t("wallet.amountToAdd")}:</strong>
    </Typography>
    <TextField
      fullWidth
      size="small"
      type="number"
      value={withdrawAmount}
      onChange={(e) => setWithdrawAmount(Number(e.target.value))}
      margin="normal"
    />
  </DialogContent>
  <DialogActions>
    <Button
      variant="outlined"
      color="error"
      onClick={handleClosePopup2}
    >
      {t("actions.cancel")}
    </Button>
    <Button
      variant="contained"
      color="primary"
      onClick={handleCreateAdd}
      disabled={!uploadedFile || withdrawAmount <= 0}
      sx={{
        mr: 1,
        borderColor: "#000",
        backgroundColor: "#000",
        "&:hover": {
          borderColor: "#333",
        },
      }}
    >
      {t("actions.save")}
    </Button>
  </DialogActions>
</Dialog>
      {/* Create Transformation Popup */}
      <Dialog open={isPopupOpen} onClose={handleClosePopup} maxWidth="sm" fullWidth>
        <DialogTitle>{t("actions.addBankAccount")}</DialogTitle>
        <DialogContent>
        <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
        {t("payment.accountName")}
        </Typography>
          <TextField
            fullWidth
            size="small"
            label=""
            value={bankAccount.accountName}
            onChange={(e) => handleBankAccountChange("accountName", e.target.value)}
            margin="normal"
          />
          <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
          {t("payment.accountNumber")}
        </Typography>
          <TextField
            fullWidth
            size="small"
            label=""
            value={bankAccount.accountNumber}
            onChange={(e) => handleBankAccountChange("accountNumber", e.target.value)}
            margin="normal"
          />
          <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
          {t("payment.bankName")}
        </Typography>
          <TextField
            fullWidth
            size="small"
            label=""
            value={bankAccount.bankName}
            onChange={(e) => handleBankAccountChange("bankName", e.target.value)}
            margin="normal"
          />
          <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
          {t("payment.iban")}
        </Typography>
          <TextField
            fullWidth
            size="small"
            label=""
            value={bankAccount.iban}
            onChange={(e) => handleBankAccountChange("iban", e.target.value)}
            margin="normal"
          />
          <Typography variant="subtitle2" sx={{ textAlign: 'right' }}>
          {t("wallet.amountToWithdraw")}
        </Typography>
          <TextField
            fullWidth
            size="small"
            label=""
            type="number"
            value={withdrawAmount}
            onChange={(e) => setWithdrawAmount(Number(e.target.value))}
            margin="normal"
          />

           <p className="text-gray-500">
    {t("wallet.withdrawnAmount")}: {AvailableCount} {t("checkout.summary.currency")}
  </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePopup} color="secondary">
            {t("actions.cancel")}
          </Button>
          <Button onClick={handleCreateTransform} color="primary" variant="contained"
           sx={{
            mr: 1,
            borderColor: "#000",
            backgroundColor: "#000",
            "&:hover": {
              borderColor: "#333",
            },
          }}
          >
            {t("actions.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default LandingpaymentSeller;
